export default "__VITE_ASSET__CIhCvUdW__"